<template>
    <div></div>
</template>
<script>
    export default {
        beforeCreate () {
            this.$store.commit('loginFormView', 2);
            localStorage.removeItem('infoModal');
            this.$store.dispatch('logoutUser').then(() => {
                this.$router.push({ name: 'Login' })
            }, () => {
                window.location.reload()
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/logout/Logout.vue